import { render, staticRenderFns } from "./ChatStats.vue?vue&type=template&id=4b76b574"
import script from "./ChatStats.vue?vue&type=script&lang=js"
export * from "./ChatStats.vue?vue&type=script&lang=js"
import style0 from "./ChatStats.vue?vue&type=style&index=0&id=4b76b574&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports